import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({

    containerStyles: {
        height: 20,
        width: '100%',
        backgroundColor: "#e0e0de",
        borderRadius: 100,
      },
    
    fillerStyles: {
        height: '100%',
        width: (props) => `${props.completed}%`,
        backgroundColor: "#3f51b5",
        borderRadius: 'inherit',
        textAlign: 'right'
      },
    
    labelStyles:  {
        padding: 5,
        color: 'white',
        fontWeight: 'bold'
      }


}));

export { useStyles };